module.exports = __webpack_public_path__ + "static/media/slices1@2x.aaec06d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/slices1@2x.png
// module id = 760
// module chunks = 0 1